export type CommunityLinkPreview = {
  url: string
  type: 'tradingview-chart'
  title: string
  imageUrl: string | null
}

const URL_REGEX = /(https?:\/\/[^\s<>"']+)/i

export function extractFirstUrlFromText(input: string): string | null {
  const raw = String(input || '')
  const match = raw.match(URL_REGEX)
  if (!match) return null
  return match[1]
}

export function extractFirstUrlFromHtml(html: string): string | null {
  return extractFirstUrlFromText(html.replace(/<[^>]+>/g, ' '))
}

export function buildLinkPreview(url: string): CommunityLinkPreview | null {
  const trimmed = String(url || '').trim()
  if (!trimmed) return null

  // TradingView share links: https://www.tradingview.com/x/XXXXXX/
  const tvMatch = trimmed.match(
    /https?:\/\/(?:www\.)?tradingview\.com\/x\/([a-zA-Z0-9]+)\//,
  )
  if (tvMatch) {
    const code = tvMatch[1]
    const canonicalUrl = `https://www.tradingview.com/x/${code}/`
    const firstChar = code.charAt(0).toLowerCase() || '0'
    const imageUrl = `https://s3.tradingview.com/snapshots/${firstChar}/${code}.png`
    return {
      url: canonicalUrl,
      type: 'tradingview-chart',
      title: 'TradingView — gráfico compartilhado',
      imageUrl,
    }
  }

  return null
}
